<template>
  <div
    class="embeddable-edit__add-placeholder flex justify-center items-center pa-8 rounded-2 overflow-hidden"
    :style="{ width: `${data?.width}`, height: `${data?.height}` }"
  >
    <CIcon :color="themeVars.primary4" :icon="ComponentIcon.Embeddable" size="36" />
  </div>
</template>

<script setup lang="ts">
import useThemeVars from '@lib/composables/useThemeVars'
import type { EmbeddableProps } from '@canvas-builder/types/canvas'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { ComponentIcon } from '@canvas-builder/types/canvas'

defineProps<{
  data?: EmbeddableProps
}>()

const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.embeddable-edit__add-placeholder {
  background: v-bind('themeVars.primary6');
}
</style>
